var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-circle",
    "data-name": "Icon awesome-user-circle",
    d: "M15,.563a15,15,0,1,0,15,15A15,15,0,0,0,15,.563Zm0,5.806a5.323,5.323,0,1,1-5.323,5.323A5.323,5.323,0,0,1,15,6.369Zm0,20.806A11.59,11.59,0,0,1,6.139,23.05,6.744,6.744,0,0,1,12.1,19.433a1.48,1.48,0,0,1,.429.067A8.008,8.008,0,0,0,15,19.917a7.978,7.978,0,0,0,2.474-.417,1.48,1.48,0,0,1,.429-.067,6.744,6.744,0,0,1,5.958,3.617A11.59,11.59,0,0,1,15,27.175Z",
    transform: "translate(0 -0.563)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user_default.b9c329409e0b5b7f20e8e924fddd3436.svg";
export { ForwardRef as ReactComponent };